/**
 * Russian for the admin panel only (owner request 2026-10-21). Participants, the bot,
 * the bridge page and the OBS stage stay English (CLAUDE.md rule 8). Keys mirror
 * `en.admin`; anything missing here falls back to English. Moderation reject reasons
 * are not translated — participants read them.
 */
export const ruAdmin = {
  admin: {
    title: 'Rudy Giveaway — админка',
    loading: 'Загружаем пульт управления',
    login: {
      heading: 'Вход в пульт управления',
      email: 'Почта',
      password: 'Пароль',
      code: 'Код из приложения-аутентификатора',
      submit: 'Войти',
      verify: 'Проверить код',
      setupHeading: 'Включите двухэтапный вход',
      setupBody:
        'Отсканируйте код в Google Authenticator, 1Password или любом TOTP-приложении и введите 6 цифр, которые оно покажет.',
      qrAlt: 'QR-код для приложения-аутентификатора',
      setupSecret: 'Не сканируется? Введите ключ вручную:',
      invalidCredentials: 'Почта и пароль не подходят ни к одному админу.',
      invalidCode: 'Код не подошёл. Коды меняются каждые 30 секунд — введите текущий.',
      attemptsLeft: 'Осталось попыток до блокировки на 15 минут: {n}.',
      locked: 'Слишком много попыток. Вход заблокирован на 15 минут.',
      setupExpired: 'Время настройки истекло. Войдите заново, чтобы получить новый QR-код.',
      network: 'Сервер недоступен. Проверьте интернет и попробуйте ещё раз.',
    },
    nav: {
      participants: 'Участники',
      audit: 'Журнал действий',
      season: 'Сезон',
      settings: 'Настройки',
      moderation: 'Модерация',
      tasks: 'Задания',
      vip: 'VIP',
      wheel: 'Колесо',
      draws: 'Розыгрыши',
      testMode: 'Тестовый режим',
      dashboard: 'Сводка',
      funnel: 'Воронка',
      broadcasts: 'Рассылки',
      sends: 'Отправки',
      links: 'Ссылки',
      conversions: 'Конверсии',
      signOut: 'Выйти',
      language: 'Язык админки',
    },
    mode: {
      test: 'Тестовый режим. Сообщения получают только тестировщики.',
      live: 'Боевой режим. Сообщения получают все.',
    },
    participants: {
      title: 'Участники',
      count: 'Человек: {n}',
      search: 'Имя, @username или Telegram id',
      allSources: 'Все источники',
      organic: 'Без ссылки',
      filters: {
        all: 'Все',
        vip: 'VIP',
        shortlist: 'Особый список',
        testers: 'Тестировщики',
        shadow: 'Тестовые (теневые)',
        blocked: 'Заблокировали бота',
        banned: 'Забанены',
      },
      sortTickets: 'Сначала больше билетов',
      sortRecent: 'Сначала новые',
      columns: {
        person: 'Участник',
        tgId: 'Telegram id',
        source: 'Источник',
        tickets: 'Билеты',
        status: 'Статус',
        joined: 'Пришёл',
      },
      badges: {
        vip: 'VIP',
        shortlist: 'Особый список',
        tester: 'Тестировщик',
        shadow: 'Теневой',
        blocked: 'Заблокировал бота',
        banned: 'Забанен',
        unsubscribed: 'Не подписан на канал',
      },
      empty: 'Никого не нашлось. Очистите поиск или выберите другой источник.',
      prev: 'Назад',
      next: 'Вперёд',
      page: 'Страница {page} из {pages}',
    },
    drawer: {
      close: 'Закрыть',
      tickets: 'билетов',
      rank: 'Место {rank} из {participants}',
      unranked: 'Пока без места',
      permanent: 'постоянных: {n}',
      inSeason: 'в этом сезоне: {n}',
      ledger: 'История билетов',
      ledgerEmpty: 'Билетов пока нет. Они появятся здесь сразу после начисления.',
      pushes: 'Сообщения',
      pushesEmpty: 'Этому человеку пока ничего не отправляли.',
      referrals: 'Приглашённые',
      invitedBy: 'Пригласил(а): {name}',
      invitedNone: 'Пока никого не пригласил.',
      notes: 'Заметки',
      notesSave: 'Сохранить заметки',
      notesSaved: 'Заметки сохранены',
      adjust: 'Изменить билеты',
      amount: 'Количество',
      reason: 'Причина (участник увидит её в истории, пишите по-английски)',
      permanentToggle: 'Постоянные — не сгорают в конце сезона',
      addTickets: 'Добавить билеты',
      removeTickets: 'Списать билеты',
      adjusted: 'История обновлена',
      message: 'Написать участнику',
      messagePlaceholder: 'Придёт ему в чат с ботом — пишите по-английски',
      messageSend: 'Отправить',
      messageQueued: 'Сообщение поставлено в очередь',
      ban: 'Забанить',
      unban: 'Снять бан',
      delete: 'Удалить участника',
      deleteConfirm:
        'Удалить {name} насовсем? Пропадут все его билеты, ответы, рефералы и история сообщений. Это нельзя отменить. Если он снова нажмёт /start, то зайдёт как новый участник.',
      deleteWinner:
        'Нельзя удалить победителя розыгрыша (розыгрыш {draws}). Используйте бан, если нужно.',
      deleteInDraw:
        'Участник есть в проведённом розыгрыше {draws}: удаление сломало бы его проверку честности. Если это был тестовый прогон — сначала удалите розыгрыш, иначе используйте бан.',
      makeTester: 'Сделать тестировщиком',
      addShortlist: 'Добавить в особый список',
      removeShortlist: 'Убрать из особого списка',
      removeTester: 'Убрать из тестировщиков',
      access: {
        heading: 'Доступ в админку',
        none: 'В админку не входит.',
        role: 'Роль в админке',
        make: 'Сделать админом',
        remove: 'Убрать из админки',
        removeConfirm: 'Убрать доступ в админку? Вход перестанет работать в течение 15 минут.',
        credentials:
          'Отправьте человеку вход. Логин: {login}, пароль: {password}. Пароль показывается один раз.',
        code: 'Спрашивать код из приложения при входе',
        codeHint:
          'При следующем входе нужно будет привязать приложение для кодов (Google Authenticator или похожее).',
        copy: 'Скопировать логин и пароль',
      },
      source: 'Источник',
      joined: 'Пришёл',
      lastOpen: 'Последний вход в приложение',
      never: 'Ни разу',
      pushStatus: {
        queued: 'в очереди',
        sent: 'отправлено',
        delivered_shadow: 'записано (теневой)',
        skipped: 'пропущено',
        failed: 'ошибка',
        blocked: 'бот заблокирован',
      },
    },
    pushes: {
      title: 'Отправки',
      body: 'Каждое сообщение бота: кому, когда, какой шаг или рассылка и чем закончилось. Дни и время по часовому поясу сезона ({tz}). Обновляется сама раз в 30 секунд.',
      today: 'Сегодня',
      yesterday: 'Вчера',
      problems: 'не дошло: {n}',
      whyTitle: 'Почему не ушло или ждёт',
      clearStatus: 'Показать все, не только «{status}»',
      status: {
        sent: 'Доставлено',
        delivered_shadow: 'Тестовый участник',
        queued: 'Ждёт отправки',
        skipped: 'Пропущено',
        failed: 'Ошибка',
        blocked: 'Заблокировали бота',
      },
      groups: {
        all: 'Все',
        funnel: 'Воронка',
        broadcast: 'Рассылки',
        other: 'Остальное',
      },
      columns: {
        time: 'Время',
        who: 'Кому',
        what: 'Что',
        status: 'Итог',
        details: 'Причина',
      },
      stepStart: 'Воронка: день {n}, {time}',
      stepAfter: 'Воронка: через {time} после старта',
      stepDraw: 'Воронка: за {n} дн. до розыгрыша, {time}',
      broadcast: 'Рассылка «{title}»',
      kinds: {
        test_send: 'Тест себе',
        admin_message: 'Сообщение из админки',
        on_task_approved: 'Задание принято',
        on_task_rejected: 'Задание отклонено',
        on_vip_approved: 'Доступ в VIP',
        on_secret_task: 'Секретное задание',
        on_bonus_spin: 'Бонусный спин',
        on_draw_winner_you: 'Победа в розыгрыше',
        on_wheel_open: 'Колесо открыто',
        on_wheel_reminder: 'Напоминание о колесе',
      },
      reasons: {
        condition: 'Не подошло условие шага (например, уже в VIP или уже есть билет)',
        step_disabled: 'Шаг выключен или удалён',
        bad_condition: 'Ошибка в условии шага',
        opted_out: 'Человек отключил такие сообщения в приложении',
        no_user_or_season: 'Нет участника или активного сезона',
        blocked: 'Человек заблокировал бота',
        deactivated: 'Аккаунт Telegram удалён',
        stale: 'Не успело уйти вовремя, отправлять уже поздно',
        test_mode_non_tester: 'Тестовый режим: получают только тестировщики',
        wait_quiet_hours: 'Ждёт утра: ночная тишина 23:00–09:00',
        wait_frequency_cap: 'Ждёт завтра: человеку уже ушло 2 сообщения за день',
      },
      noName: 'Без имени',
      withMedia: 'С фото или видео',
      clicked: 'Нажал кнопку',
      inQueue: 'В очереди',
      empty: 'За этот день отправок нет.',
      more: 'Показать ещё',
    },
    audit: {
      title: 'Журнал действий',
      empty: 'Действий админов пока нет.',
      more: 'Показать ещё',
      columns: {
        when: 'Когда',
        who: 'Кто',
        action: 'Действие',
        target: 'Объект',
        details: 'Детали',
      },
    },
    season: {
      title: 'Сезон',
      modeHeading: 'Режим рассылки',
      testBody:
        'В тестовом режиме каждое сообщение помечается [TEST] и уходит только тестировщикам. Теневым (тестовым) участникам ничего не отправляется — только запись в журнал.',
      liveBody: 'В боевом режиме воронка, пуши и объявления о розыгрыше уходят всем участникам.',
      goLive: 'Включить боевой режим',
      backToTest: 'Вернуть тестовый режим',
      confirmLabel: 'Для подтверждения введите название сезона: {name}',
      ownerOnly: 'Это может сделать только владелец.',
      switched: 'Режим изменён',
      noneActive: 'Сейчас нет активного сезона',
      details: 'Параметры сезона',
      name: 'Название сезона',
      prize: 'Приз',
      startsAt: 'Начало',
      tzHint: 'Начало, конец и розыгрыш выше указаны по этому поясу.',
      endsAt: 'Конец',
      drawAt: 'Финальный розыгрыш',
      tz: 'Часовой пояс',
      startBonus: 'Стартовый бонус VIP, билетов',
      startBonusHint: 'Начисляется каждому VIP-участнику при старте сезона.',
      revealMode: 'Раскрытие машины в Гараже считается от',
      revealSeason: 'Дат сезона: открывается от начала до конца, полностью — в последний день',
      revealPersonal: 'Первого дня каждого участника в боте',
      revealDays: 'За сколько дней открывается полностью (от первого дня участника)',
      revealHint: 'В 1-й день видна морда машины, полное фото — в последний день.',
      prizeImage: 'Путь к фото приза',
      prizeImageHint: 'Например /app/assets/tesla-hero.jpg.',
      save: 'Сохранить параметры',
      endTitle: 'Завершение сезона',
      burnPreview:
        'Сгорит сезонных билетов: {burn} у {users} человек. Постоянные билеты ({remain}: за канал и VIP) переходят в следующий сезон.',
      endBody:
        'Завершение сжигает сезонные билеты в истории и закрывает сезон. Из каналов никого не удаляем. Сначала проведите финальный розыгрыш.',
      end: 'Завершить сезон',
      ended: 'Сезон завершён: сгорело {burned} билетов у {users} человек.',
      reopenTitle: 'Завершили по ошибке?',
      reopenBody:
        '«{name}» завершён. Если вернуть сезон, он снова станет текущим, а сгоревшие билеты вернутся участникам; их прогресс сохранится.',
      reopen: 'Вернуть сезон',
      nextTitle: 'Следующий сезон',
      nextBody:
        'Готовьте следующий приз, пока идёт текущий. Задания, награды и воронка копируются из текущего сезона; новый сезон стартует в тестовом режиме.',
      draft: 'Черновик',
      start: 'Запустить этот сезон',
      endFirst: 'Сначала завершите текущий сезон.',
      started: 'Сезон запущен. Стартовый бонус получили VIP-участников: {n}.',
      create: 'Подготовить новый сезон',
      createButton: 'Создать черновик',
    },
    wheelAdmin: {
      title: 'Колесо',
      week: 'Неделя {n}',
      shown: 'Колесо показывается в приложении',
      hidden: 'Колесо скрыто',
      shownBody: 'Участники видят вкладку «Wheel» и получают пуши «колесо открыто».',
      hiddenBody:
        'Колесо никто не видит: на его месте в приложении кнопка «Support» (чат поддержки), пуши про колесо не уходят, прокрутки отклоняются.',
      show: 'Показать колесо',
      hide: 'Скрыть колесо',
      sectors: 'Секторы',
      sectorsBody:
        'Веса относительные. Чем больше у человека билетов, тем выше шанс на призовой сектор; остаток 0 отключает сектор.',
      label: 'Название',
      kind: 'Тип',
      kinds: { physical: 'Физический приз', cash: 'Деньги', tickets: 'Билеты', nothing: 'Пусто' },
      value: 'Значение',
      weight: 'Вес',
      stock: 'Остаток',
      unlimited: 'Без ограничений',
      photo: 'Фото',
      photoUpload: 'Загрузить',
      photoUploading: 'Загружаем…',
      photoRemove: 'Убрать',
      photoNone: 'нет',
      photoDefault: 'Фото по умолчанию (загрузите своё, чтобы заменить)',
      photoSaveFirst: 'Сначала сохраните секторы',
      addSector: 'Добавить сектор',
      save: 'Сохранить секторы',
      preview: 'Шансы',
      previewBody: 'Шанс выиграть любой приз для человека с таким числом билетов.',
      tickets: '{n} билетов',
      spins: 'Последние вращения',
      claims: 'Призы к отправке',
      claimEmpty: 'Отправлять пока нечего.',
      claimStatuses: {
        awaiting_address: 'Ждём адрес',
        address_received: 'Адрес получен',
        shipped: 'Отправлено',
      },
      shipped: 'Отметить как отправленное',
      bonus: 'Выдать бонусное вращение',
      bonusUser: 'ID участника',
      giveBonus: 'Выдать',
      scarcity: 'Подсвечивать, что физических призов осталось мало',
      opensAt: 'Открывается',
      closesAt: 'Закрывается',
      saveSchedule: 'Сохранить расписание',
      wall: 'Стена победителей',
      wallName: 'Имя',
      wallCity: 'Город',
      wallPrize: 'Приз',
      wallMedia: 'Ссылка на фото',
      addWinner: 'Добавить на стену',
    },
    drawsAdmin: {
      title: 'Розыгрыши',
      create: 'Новый розыгрыш',
      type: 'Тип',
      types: { final: 'Финальный (машина)', extra: 'Дополнительный' },
      drawTitle: 'Название',
      prize: 'Приз',
      scheduledAt: 'Дата и время',
      weighting: 'Как считать шансы',
      weightings: { tickets: 'По числу билетов', equal: 'Один шанс у каждого' },
      eligibility: 'Кто участвует',
      activeToday: 'Заходили в приложение сегодня',
      vipOnly: 'Только VIP',
      shortlistOnly: 'Только из особого списка',
      minTickets: 'Не меньше {n} билетов',
      minTicketsLabel: 'Минимум билетов',
      joinedBefore: 'Пришли до {date}',
      joinedBeforeLabel: 'Пришли до',
      includeShadow: 'Включить теневых (тестовых) участников',
      everyone: 'Все, у кого есть билет',
      eligibilityHint:
        'Ничего не отмечено — участвуют все, у кого есть билет. Каждая галочка сужает круг: человек должен подходить под все отмеченные условия сразу.',
      vipOnlyHint: 'Только те, кто вступил в VIP-канал.',
      shortlistOnlyHint:
        'Только те, кого вы добавили кнопкой в карточке участника (Участники → карточка → «Добавить в особый список»).',
      activeTodayHint:
        'Только те, кто открыл приложение сегодня. Удобно для розыгрыша в эфире среди тех, кто смотрит.',
      optional: 'Не обязательно',
      reach: 'Сейчас подходят: {people} чел., у них {tickets} билетов.',
      nobody:
        'Сейчас никто не подходит под эти условия. Розыгрыш не получится провести — ослабьте условия: уберите галочки или уменьшите «Минимум билетов».',
      nobodyFix:
        'Отмените этот розыгрыш и создайте новый с меньшим числом условий (или добавьте людей в особый список).',
      errors: {
        empty_snapshot:
          'Никто не подходит под условия этого розыгрыша, поэтому его нельзя провести. Уберите часть галочек: отмените этот розыгрыш и создайте новый.',
        bad_status: 'Этот шаг уже сделан или розыгрыш отменён. Обновите страницу.',
        no_active_season:
          'Нет активного сезона. Сначала верните или запустите сезон в разделе «Сезон».',
        forced_live_season: 'Назначать победителя можно только в тестовом режиме.',
      },
      createDraw: 'Создать розыгрыш',
      statuses: {
        scheduled: 'Запланирован',
        committed: 'Хеш опубликован',
        drawing: 'Идёт розыгрыш',
        awaiting_winner: 'Ждём победителя',
        completed: 'Завершён',
        cancelled: 'Отменён',
      },
      commit: 'Зафиксировать (опубликовать хеш)',
      commitBody:
        'Замораживает список билетов и публикует хеш честности. Делайте это за 24 часа до розыгрыша.',
      channelPost: 'Пост для канала',
      run: 'Провести розыгрыш',
      redraw: 'Перекрутить',
      redrawConfirm:
        'Перекрутить? Текущий победитель потеряет выигрыш, система выберет другого. Это нельзя отменить.',
      cancel: 'Отменить розыгрыш',
      cancelConfirm: 'Отменить этот розыгрыш? Участники перестанут его видеть.',
      remove: 'Удалить розыгрыш',
      photo: 'Фото победителю',
      photoHint:
        'Бот пришлёт его победителю вместе с подтверждением, когда тот нажмёт «I’m here». Удобно показать на стриме.',
      photoUpload: 'Загрузить фото',
      photoReplace: 'Заменить фото',
      photoRemove: 'Убрать фото',
      photoUploading: 'Загружаем…',
      removeConfirm:
        'Удалить этот розыгрыш? Победитель пропадёт из приложения. Запись останется в журнале.',
      dryRun: 'Пробный прогон',
      dryResult: 'Выиграл бы: {name}, билет {index} из {total}',
      stage: 'Открыть сцену для OBS',
      verify: 'Страница проверки',
      attempts: 'Попытки',
      attempt: 'Попытка {n}',
      responded: 'Подтвердил {time}',
      timedOut: 'Не ответил — время вышло',
      waiting: 'Ждём до {time}',
      forced: 'Назначен',
      forceWinner: 'Назначить победителя (только тестовый режим)',
      forceWinnerHint:
        'ID тестировщика или теневого участника. Сцена отработает точно так же, как в боевом режиме.',
      saveForce: 'Сохранить победителя',
      outcome: 'Итог приза',
      outcomes: {
        car: 'Машина',
        cash_alternative: 'Деньгами вместо машины',
        declined: 'Отказался',
      },
      empty: 'Розыгрышей пока нет. Создайте финальный розыгрыш сезона.',
      snapshot: 'Билетов в снимке: {n}',
    },
    dashboard: {
      title: 'Сводка',
      participants: 'Участники',
      participantsNote: 'Заблокировали бота: {blocked}',
      ticketsToday: 'Билетов выдано сегодня',
      ticketsTotal: 'Билетов в игре',
      vipJoins: 'В VIP',
      vipToday: '+{n} сегодня',
      activeToday: 'Заходили в приложение сегодня',
      pushesToday: 'Сообщений отправлено сегодня',
      pending: 'Ждут модерации',
      next: 'Ближайшее',
      nextWheel: 'Колесо откроется {when}',
      nextWheelOpen: 'Колесо открыто до {when}',
      nextDraw: '{title} — {when}',
      noDraw: 'Розыгрыш не запланирован',
      nextFunnel: 'Сообщений воронки в ближайшие 24 ч: {n}',
      funnelTitle: 'От ссылки до VIP',
      funnelBody: 'Все, кто запустил бота, из всех источников. Проценты — от предыдущего шага.',
      stageJoined: 'Запустили бота',
      stageSubscribed: 'Подписались на канал',
      stageOpened: 'Открыли приложение',
      stageVip: 'Вступили в VIP',
      ofPrevious: '{pct} от предыдущего шага',
      ofJoined: '{pct} от всех пришедших',
      sourcesTitle: 'Источники',
      sourcesBody: 'Главная цифра для оценки рекламы — переход в VIP.',
      organic: 'Без ссылки',
      colSource: 'Источник',
      colClicks: 'Клики',
      colJoined: 'Запустили',
      colSubscribed: 'Подписались',
      colOpened: 'Приложение',
      colVip: 'VIP',
      colVipRate: 'В VIP',
      heatTitle: 'Когда люди собирают билеты',
      heatBody: 'Начисления по дням недели и часам за последние 28 дней, {tz}.',
      heatCell: '{day} {hour}:00 — начислений: {n}',
      heatLess: 'Меньше',
      heatMore: 'Больше',
      days: 'Пн,Вт,Ср,Чт,Пт,Сб,Вс',
      cohortsTitle: 'Когорты по неделе прихода',
      colWeek: 'Неделя',
      colAvg: 'Билетов в среднем',
      exports: 'Выгрузка CSV',
      exportParticipants: 'Участники',
      exportWinners: 'Победители с адресами',
      exportLedger: 'История билетов',
      empty: 'Пока пусто — цифры появятся, как только первые люди запустят бота.',
    },
    funnel: {
      intro: {
        title: 'Начало воронки',
        body: 'Эти два сообщения получает каждый новый человек до шагов по дням. Подстановки: {tokens}.',
        welcomeTitle: 'После /start: подпишись на канал',
        welcomeBody:
          'Первое сообщение, когда человек нажал Start. Под ним кнопки «Open the channel» и «I subscribed». Сюда можно поставить фото, видео, кружок или голосовое.',
        ticketTitle: 'После «I subscribed»: билет №1',
        ticketBody:
          'Приходит, когда бот проверил подписку и выдал первый билет. С этого момента начинаются шаги ниже.',
        resetText: 'Вернуть текст по умолчанию',
        save: 'Сохранить начало воронки',
        saved: 'Сохранено. Новые люди получат это через несколько секунд.',
        next: 'Дальше — шаги по дням ниже: день 0 считается от нажатия Start.',
      },
      title: 'Воронка',
      body: 'Личные сообщения на N-й день после запуска бота и общий отсчёт до финального розыгрыша. Время — {tz}. Изменения работают со следующей минуты; сообщение из очереди всегда уходит с последним текстом. Тексты пишите по-английски — их читают участники.',
      rules: 'Правила доставки',
      quietFrom: 'Тишина с',
      quietTo: 'Тишина до',
      cap: 'Максимум сообщений одному человеку в день',
      capHint: 'Сообщения о призах и розыгрыше идут без лимита.',
      saveRules: 'Сохранить правила',
      myTg: 'Ваш Telegram id (для тестовой отправки)',
      myTgHint: 'Сначала нажмите /start в боте с этого аккаунта.',
      saveMyTg: 'Сохранить id',
      steps: 'Шаги',
      addStep: 'Новый шаг',
      colDay: 'День',
      colTime: 'Время',
      colWho: 'Условие',
      colMessage: 'Сообщение',
      colDue: 'Ближайшие 24 ч',
      colSent: 'Отправлено',
      colDelivered: 'Доставлено',
      colClicked: 'Переходы',
      dayN: 'День {n}',
      beforeDraw: 'За {n} дн. до розыгрыша',
      dayBeforeDraw: 'Накануне розыгрыша',
      drawDay: 'День розыгрыша',
      anchor: 'Отсчёт от',
      anchorStart: 'Дня, когда человек запустил бота',
      anchorDraw: 'Финального розыгрыша (всем в один момент)',
      daysBefore: 'За сколько дней до розыгрыша',
      reset: 'Вернуть стандартную воронку',
      resetConfirm:
        'Все шаги этого сезона заменятся стандартной воронкой. Для подтверждения введите reset.',
      resetDone: 'Воронка сброшена: стандартных шагов {n}.',
      afterStart: 'через {time} после старта',
      variant: '{v} · {pct} %',
      off: 'Выкл.',
      edit: 'Редактировать шаг',
      create: 'Новый шаг',
      dayOffset: 'День после старта',
      sendTime: 'Время',
      sendTimeHint: '12:00 — в этот день в 12:00. +02:00 — через два часа после запуска бота.',
      condition: 'Отправлять, только если',
      conditionHint:
        'Данные: {facts}. Комбинируйте через && (и), || (или), ! (не) и сравнения, например tickets < 5.',
      variantLabel: 'Вариант',
      split: 'Доля людей, %',
      template: 'Текст сообщения (по-английски)',
      templateHint: 'Подстановки: {tokens}',
      buttons: 'Кнопки',
      addButton: 'Добавить кнопку',
      removeButton: 'Убрать',
      buttonLabel: 'Текст кнопки',
      buttonAction: 'Открывает',
      enabled: 'Включён',
      save: 'Сохранить шаг',
      saved: 'Сохранено. Сработает со следующей минуты.',
      remove: 'Удалить шаг',
      removeConfirm: 'Удалить шаг? Сообщения по нему, стоящие в очереди, будут пропущены.',
      addVariant: 'Добавить вариант B',
      test: 'Отправить тест себе',
      testSent: 'Отправлено вам в Telegram.',
      media: {
        title: 'Вложение',
        none: 'Только текст',
        kinds: {
          video_note: 'Кружок',
          voice: 'Голосовое',
          video: 'Видео',
          photo: 'Картинка',
        },
        hint: {
          video_note:
            'Круглое видео. Запишите кружок в Telegram и отправьте боту или загрузите квадратный MP4 до 1 минуты.',
          voice:
            'Голосовое сообщение. Запишите в Telegram и отправьте боту или загрузите OGG / MP3.',
          video: 'Видео, текст шага идёт подписью. MP4 до 50 МБ.',
          photo: 'Картинка, текст шага идёт подписью. JPG, PNG или WebP.',
        },
        empty: 'В медиатеке пока нет файлов этого типа.',
        upload: 'Загрузить с компьютера',
        linkTitle: 'Привяжите свой Telegram, чтобы загружать файлы',
        linkBody:
          'Бот один раз отправит файл вам в личку, чтобы Telegram его сохранил, и сразу удалит сообщение. Нажмите кнопку, в боте нажмите Start — загрузка продолжится сама.',
        linkButton: 'Привязать Telegram',
        uploading: 'Загружаю…',
        refresh: 'Обновить список',
        delete: 'Удалить из медиатеки',
        deleteConfirm: 'Удалить «{title}» из медиатеки? Это нельзя отменить.',
        viaBot:
          'С телефона: отправьте файл боту со своего Telegram (того, что привязан к вашему аккаунту админки) и нажмите «Обновить список».',
        circleNote: 'К кружку нельзя прикрепить текст: текст и кнопки придут следующим сообщением.',
      },
      preview: 'Предпросмотр',
      previewFor: 'Подставлено для {name}',
      matches: 'Этот человек получил бы его сейчас.',
      notMatches: 'Этот человек сейчас бы его не получил.',
      close: 'Закрыть',
      empty: 'Шагов пока нет.',
      everyone: 'всем',
      nobody: 'никому',
      conditionBroken: '— в условии ошибка, см. ниже',
      readsAs: 'Читается как: {text}',
      and: 'и',
      or: 'или',
      not: 'не',
      facts: {
        tickets: 'билетов',
        has_ticket: 'есть билет',
        no_ticket: 'нет билета',
        has_vip: 'в VIP',
        opened_app: 'открывал приложение',
        no_app_open_days: 'дней без захода в приложение',
        referral_sent: 'пригласил друга',
        not_spun_this_week: 'не крутил колесо на этой неделе',
        is_saturday_or_next: 'колесо открыто или откроется в ближайшие сутки',
        streak_days: 'дней подряд в приложении',
        rank: 'место в рейтинге',
        source: 'источник',
        is_tester: 'тестировщик',
        reveal_day: 'день раскрытия машины',
      },
      actions: {
        open_app: 'Приложение — Гараж',
        'open_app:tasks': 'Приложение — Задания',
        'open_app:rank': 'Приложение — Рейтинг',
        'open_app:wheel': 'Приложение — Колесо',
        'open_app:vip': 'Приложение — VIP',
        'open_app:draw': 'Приложение — Розыгрыш',
        'open_app:friends': 'Приложение — Пригласить друзей',
        support_link: 'Чат с поддержкой (с REF-кодом)',
        channel_link: 'Основной канал',
        check_subscribe: 'Проверка подписки',
      },
    },
    broadcasts: {
      title: 'Рассылки',
      body: 'Разовое сообщение всем, кто подходит под условие. Доставка соблюдает дневной лимит и часы тишины. Текст пишите по-английски.',
      compose: 'Новая рассылка',
      name: 'Название (видят только админы)',
      segment: 'Кому: людям, у которых',
      segmentHint: 'Оставьте true, чтобы отправить всем. Те же данные, что в воронке.',
      estimate: 'Посчитать людей',
      estimateResult: 'Сейчас подходит человек: {n}',
      saveDraft: 'Сохранить черновик',
      sendNow: 'Отправить сейчас',
      sendConfirm: 'Отправить «{title}» всем подходящим прямо сейчас?',
      scheduleAt: 'Отправить в',
      schedule: 'Запланировать',
      cancel: 'Отменить',
      list: 'Все рассылки',
      empty: 'Рассылок пока нет.',
      statuses: {
        draft: 'Черновик',
        scheduled: 'Запланирована',
        sending: 'Отправляется',
        done: 'Отправлена',
        cancelled: 'Отменена',
      },
      progress: 'Доставлено {sent} из {target}',
      waiting: 'Ждут лимита или конца тишины: {n}',
      clicked: 'Открыли приложение: {n}',
      skippedFailed: 'Не доставлено: {n}',
      scheduledFor: 'Уйдёт {when}',
      problems: 'Проблемы с доставкой',
      problemsBody:
        'Сообщения, которые не ушли после пяти попыток (ошибки Telegram, таймауты). Тех, кто заблокировал бота, здесь нет — им больше не пишем.',
      problemsNone: 'Недоставленных сообщений нет.',
      stuck:
        'Сообщений висит в очереди дольше 36 часов: {n}. Проверьте, что бот и воркер запущены (RUNBOOK).',
      retryAll: 'Повторить все',
      retried: 'Снова в очереди: {n}.',
    },
    links: {
      title: 'Ссылки',
      body: 'Одна ссылка на каждую рекламу, рилс или пост. Человек попадает на короткую страницу, которая открывает бота и запоминает клик для отчёта о конверсиях.',
      build: 'Новая ссылка',
      utmSource: 'Источник',
      utmCampaign: 'Кампания',
      utmAdgroup: 'Группа объявлений',
      utmContent: 'Креатив',
      label: 'Заметка',
      code: 'Код (необязательно)',
      codeHint: 'Латиница, цифры, _ и -. Если пусто — соберётся из полей.',
      create: 'Создать ссылку',
      list: 'Все ссылки',
      bridge: 'Ссылка для рекламы',
      deepLink: 'Прямая ссылка на бота',
      copy: 'Копировать',
      copied: 'Скопировано',
      qr: 'QR-код',
      downloadQr: 'Скачать SVG',
      hideQr: 'Скрыть QR',
      empty: 'Ссылок пока нет. Сделайте отдельную на каждую рекламу, чтобы их сравнивать.',
    },
    conversions: {
      title: 'Конверсии',
      body: 'Отправляем в рекламные сети первые билеты и вступления в VIP, чтобы они оптимизировались на тех, кто доходит до конца. Ключи хранятся в .env на сервере, включение — здесь.',
      tiktok: 'TikTok Events API',
      tiktokBody:
        'Первый билет → CompleteRegistration, вступление в VIP → SubmitForm, с ttclid со страницы ссылки.',
      tgbooster: 'Постбэк TgBooster',
      tgboosterBody:
        'Первый билет и вступление в VIP → постбэк с хешем объявления из стартовой ссылки.',
      configured: 'Ключи заданы',
      notConfigured: 'Нет ключей в .env',
      on: 'Отправляет',
      offState: 'Выключено',
      turnOn: 'Включить',
      turnOff: 'Выключить',
      ownerOnly: 'Включать и выключать может только владелец.',
      ping: 'Отправить тестовое событие',
      pingResult: 'Тестовое событие: {status}',
      counts: 'Отправлено {sent}, с ошибкой {failed}',
      log: 'Журнал отправок',
      empty: 'Пока ничего не отправляли.',
      colTime: 'Время',
      colAdapter: 'Сеть',
      colEvent: 'Событие',
      colPerson: 'Участник',
      colStatus: 'Статус',
      colResponse: 'Ответ',
      statuses: { pending: 'ожидает', sent: 'отправлено', failed: 'ошибка' },
    },
    testMode: {
      title: 'Тестовый режим',
      body: 'Прогоняйте любые сценарии на тестировщиках и теневых участниках. Пока сезон в тестовом режиме, реальные участники ничего не получат.',
      liveWarning: 'Сезон в боевом режиме — сценарии отключены.',
      target: 'Тестировщик',
      targetHint: 'ID участника-тестировщика (он должен был нажать /start).',
      noResponse: 'Победитель не отвечает',
      noResponseBody:
        'Завершает ожидание текущего победителя последнего розыгрыша и перекручивает.',
      forceSector: 'Колесо: задать сектор следующего вращения тестировщика',
      sector: 'Сектор',
      unsubscribe: 'Имитировать отписку',
      vipJoin: 'Имитировать вступление в VIP',
      done: 'Готово',
    },
    vipAdmin: {
      title: 'VIP',
      requests: 'Заявки',
      requestsBody:
        'Люди, нажавшие «Написать в поддержку», с кодом из их сообщения. «Одобрить» отправляет им одноразовое приглашение.',
      empty: 'Заявок в VIP пока нет.',
      statuses: {
        new: 'Новая',
        talked: 'На связи',
        approved: 'Одобрена',
        joined: 'Вступил',
        declined: 'Отклонена',
      },
      waitingJoin: 'Нажал на приглашение',
      approve: 'Одобрить и отправить приглашение',
      approveNow: 'Одобрить и впустить',
      talked: 'Отметить «на связи»',
      decline: 'Отклонить',
      revoke: 'Убрать из VIP',
      note: 'Заметка',
      results: 'Результаты',
      resultsBody:
        'Показываются на экране VIP. Результат «сигнала дня» видят все, а вход в сделку — только участники VIP. Тексты пишите по-английски.',
      resultTitle: 'Заголовок',
      resultValue: 'Результат',
      resultEntry: 'Вход (только для VIP)',
      signalOfDay: 'Сигнал дня',
      addResult: 'Добавить результат',
      removeResult: 'Убрать',
      removeResultConfirm: 'Убрать этот результат из списка в приложении?',
      lessons: 'Уроки',
      lessonsBody: 'Пять уроков, за каждый пройденный VIP-участник получает +1 билет.',
      lessonTitle: 'Название урока (по-английски)',
      lessonUrl: 'Ссылка (пост в канале или видео)',
      saveLessons: 'Сохранить уроки',
      channelMissing: 'Сначала укажите VIP-канал в Настройках — приглашения создаются в нём.',
    },
    moderation: {
      title: 'Модерация',
      pending: 'Ждут: {n}',
      empty: 'Очередь пуста. Новые скриншоты появятся здесь сразу после отправки.',
      approve: 'Принять',
      reject: 'Отклонить',
      approveAll: 'Принять все ({n})',
      imageMissing: 'Скриншот не найден на сервере. Отклоните заявку и попросите прислать снова.',
      approveAllConfirm:
        'Принять {n} заявок и начислить билеты? Заявки с повторными скриншотами ({skipped}) останутся — их проверьте вручную.',
      reasonLabel: 'Причина, которую увидит участник (по-английски)',
      keys: 'Клавиши: A — принять, R — отклонить, J и K — по очереди.',
      handle: 'Указанный ник',
      noHandle: 'Ник не указан',
      duplicate: 'Такую же картинку прислали ещё {n} человек',
      duplicateOne: 'Такую же картинку прислал ещё 1 человек',
      history: 'Раньше принято {approved}, отклонено {rejected}',
      vip: 'VIP',
      swipeHint: 'Свайп вправо — принять, влево — отклонить',
      approved: 'Принято, +{n}',
      rejected: 'Отклонено',
    },
    tasksAdmin: {
      title: 'Задания',
      catalog: 'Каталог заданий',
      catalogBody:
        'Включайте и выключайте задания и задавайте награду. Множитель VIP ×1.5 добавляется автоматически. Названия заданий видят участники — они на английском.',
      reward: 'Награда',
      enabled: 'Вкл.',
      vipNote:
        'Новая награда за VIP действует для тех, кто вступит в VIP с этого момента; уже выданные билеты не меняются.',
      streams: 'Прямые эфиры',
      streamsBody: 'Создайте эфир с кодовым словом, а когда скажете его в эфире — откройте окно.',
      streamTitle: 'Название эфира',
      codeWord: 'Кодовое слово',
      createStream: 'Создать эфир',
      openWindow: 'Открыть окно на 30 минут',
      closeWindow: 'Закрыть окно',
      liveUntil: 'Открыто до {time}',
      closed: 'Закрыто',
      notOpened: 'Ещё не открывали',
      campaigns: 'Кампании репостов',
      campaignTitle: 'Название кампании',
      hashtag: 'Хештег (необязательно)',
      link: 'Ссылка на сторис (необязательно)',
      createCampaign: 'Добавить кампанию',
      quizzes: 'Викторины',
      quizTitle: 'Название викторины',
      quizHelp:
        'Один вопрос — один блок: вопрос в первой строке, дальше варианты. Перед правильным поставьте *. Пишите по-английски.',
      createQuiz: 'Добавить викторину',
      videos: 'Видео',
      videoTitle: 'Название видео',
      videoUrl: 'Ссылка на видео (mp4)',
      videoDuration: 'Длина, секунд',
      createVideo: 'Добавить видео',
      secret: 'Секретное задание',
      secretBody:
        'Видно только после пуша. Включение один раз на этой неделе уведомит всех участников.',
      instructions: 'Что нужно сделать (по-английски)',
      secretOn: 'Включить и уведомить',
      secretOnConfirm: 'Включить секретное задание? Сообщение о нём сразу уйдёт всем участникам.',
      secretOff: 'Выключить',
      notified: 'Уведомлено человек: {n}',
      saved: 'Сохранено',
      active: 'Активно',
      paused: 'На паузе',
      pause: 'Пауза',
      resume: 'Возобновить',
    },
    settings: {
      title: 'Настройки',
      telegramHeading: 'Каналы Telegram',
      telegramBody:
        'Бот проверяет подписку на основной канал, впускает одобренных людей в VIP и считает комментарии в группе обсуждения. Добавьте @{bot} администратором в каждый и проверьте здесь.',
      mainChannel: 'Основной канал',
      mainChannelHint:
        'Числовой id (-100…) или @username. Канал закрытый? Перешлите любой пост в @userinfobot — он покажет id.',
      mainChannelLink: 'Пригласительная ссылка основного канала',
      mainChannelLinkHint:
        'Стоит на кнопке «Open the channel». Нажмите «Проверить» — ссылка подставится сама.',
      vipChannel: 'VIP-канал',
      discussionGroup: 'Группа обсуждения',
      supportUsername: 'Поддержка: username или ссылка на чат',
      supportUsernameHint:
        'Кто общается с кандидатами в VIP. @username — код REF подставится в сообщение сам. Ссылка https://t.me/… (например бизнес-ссылка t.me/m/…) откроется как есть, а код участник вставит из буфера.',
      check: 'Проверить',
      supportMissing:
        'Аккаунт поддержки не указан: кнопки «Talk to Support» скрыты, участники видят «Support isn’t connected yet».',
      checking: 'Проверяем',
      useLink: 'Использовать эту ссылку',
      botAdmin: 'Бот — администратор',
      botNotAdmin: 'Бот здесь ещё не администратор — добавьте @{bot} администратором',
      cannotInvite: 'Бот не может приглашать — включите «Приглашать по ссылке»',
      notFound: 'Telegram не знает этот чат, или бота в нём ещё нет.',
      fromEnv: 'из .env',
      save: 'Сохранить настройки',
      saved: 'Сохранено. Бот подхватит в течение 10 секунд.',
      media: 'Картинка или видео в сообщениях бота',
      mediaBody:
        'Картинка, видео, кружок или голосовое, которое бот отправит вместе с сообщением. Файлы берутся из медиатеки: загрузите с компьютера или отправьте боту со своего Telegram. «Только текст» — без вложения.',
      welcomeVideo: 'Приветствие (первое сообщение после /start)',
      ticketVideo: 'Сообщение «билет №1 твой» (после подписки)',
      saveMedia: 'Сохранить',
      mediaSaved: 'Сохранено. Новые люди получат это вложение.',
      backups: 'Резервные копии',
      backupLatest: 'Последняя копия: {when}, {size}.',
      backupNone: 'Копий пока нет — первая сделается этой ночью.',
      backupStale: 'Это было больше суток назад: проверьте сервис бэкапов.',
      backupBody:
        'Каждую ночь делается полная копия базы, на сервере хранятся последние 14. Как восстановить — в docs/RUNBOOK.md.',
      team: {
        heading: 'Команда',
        body: 'Кто может входить в эту админку. Заводите каждому свой вход: его действия будут видны под его почтой в журнале.',
        roles: {
          owner: 'Владелец',
          admin: 'Админ',
          support: 'Поддержка',
        },
        roleHints: {
          owner: 'Всё, включая боевой режим, завершение сезона и команду.',
          admin:
            'Всё, кроме боевого режима, завершения сезона и команды. Может проводить розыгрыши.',
          support:
            'Участники, модерация и заявки в VIP. Не меняет настройки и не проводит розыгрыши.',
        },
        you: 'вы',
        noCode: 'Ещё не входил',
        lastLogin: 'Последний вход {when}',
        email: 'Почта',
        role: 'Роль',
        add: 'Добавить в команду',
        passwordFor:
          'Отправьте {email} этот пароль: {password}. Он показывается один раз. При первом входе человек привяжет приложение для кодов (Google Authenticator или похожее).',
        copy: 'Скопировать',
        copied: 'Скопировано',
        reset: 'Сбросить вход',
        resetConfirm: 'Сбросить вход для {email}? Старый пароль перестанет работать.',
        remove: 'Удалить',
        removeConfirm: 'Удалить {email} из команды?',
        confirm: 'Да',
        cancel: 'Отмена',
      },
      testersHeading: 'Тестировщики',
      testersBody:
        'В тестовом режиме сообщения получают только тестировщики. Откройте «Участники», найдите человека (он должен сначала нажать /start) и выберите «Сделать тестировщиком».',
    },
    ledger: {
      manual: 'Ручная корректировка',
      season_end: 'Сгорание в конце сезона',
      season_start_bonus: 'Бонус VIP на старте сезона',
      wheel_sector_tickets: 'Колесо: билеты',
      wheel_streak: 'Колесо: серия',
      activity_lottery: 'Лотерея активности',
      vip_lesson: 'Урок VIP',
      revoke: 'Отозвано',
      channel_subscribe: 'Подписка на канал',
      vip_join: 'Вход в VIP',
      follow_instagram: 'Подписка в Instagram',
      follow_tiktok: 'Подписка в TikTok',
      repost_story: 'Репост в сторис',
      stream_attend: 'Стрим',
      daily_streak: 'Серия 7 дней',
      price_guess: 'Прогноз цены',
      quiz: 'Квиз',
      watch_video: 'Просмотр видео',
      comment: 'Комментарий',
      referral: 'Приглашённый друг',
      team_pool: 'Команда',
      secret_task: 'Секретное задание',
    },
    errors: {
      generic: 'Не получилось: {message}',
      forbidden: 'Вашей роли это недоступно. Обратитесь к владельцу.',
      badInput: 'Проверьте заполненные поля: какое-то значение не подходит.',
      badField: 'Проверьте поле «{field}»: значение не подходит.',
      codes: {
        media_in_use:
          'Этот файл ещё прикреплён к шагу воронки, к началу воронки или к неотправленной рассылке. Сначала поставьте там другой файл, потом удаляйте.',
        media_not_picked:
          'Выбран тип вложения, но файл не выбран. Выберите файл или нажмите «Только текст».',
        bad_path: 'Путь к файлу должен начинаться с /app/assets/ или https://.',
        chat_not_found: 'Бот не видит этот канал или чат. Проверьте id и что бот там админ.',
        confirmation_required: 'Подтверждение не совпало — введите слово точно как указано.',
        in_the_past: 'Это время уже прошло. Выберите время в будущем.',
        no_file: 'Файл не выбран.',
        not_an_image: 'Нужна картинка JPG, PNG или WebP.',
        secret_needs_instructions: 'Сначала напишите, что нужно сделать в секретном задании.',
        telegram_rejected:
          'Telegram не принял файл. Проверьте формат: MP4 для видео и кружка, OGG/MP3 для голосового, JPG для фото.',
        not_found: 'Не нашли — возможно, это уже удалили. Обновите страницу.',
        already_done: 'Это уже сделано.',
        already_sent: 'Эту рассылку уже отправили — её нельзя менять.',
        already_vip: 'Участник уже в VIP.',
        bad_status: 'Сейчас это действие недоступно — обновите страницу, статус уже изменился.',
        bot_not_configured: 'Бот не подключён на сервере (нет токена). Обратитесь к разработчику.',
        code_taken: 'Такой код уже занят. Придумайте другой.',
        email_taken: 'У этого email уже есть доступ.',
        forced_live_season: 'В боевом сезоне победителя назначить нельзя.',
        no_active_season: 'Нет активного сезона. Запустите сезон в разделе «Сезон».',
        no_wheel: 'Колесо на эту неделю не настроено.',
        not_pending: 'Эту заявку уже обработали.',
        self: 'Нельзя менять собственный доступ.',
        shadow: 'Тестовым пользователям нельзя дать доступ к админке.',
        too_large: 'Файл больше 50 МБ. Сожмите его и попробуйте снова.',
        locked: 'Слишком много попыток. Подождите 15 минут.',
        telegram_download_failed: 'Telegram не отдал файл. Попробуйте ещё раз.',
        no_admin_tg:
          'Сначала привяжите свой Telegram (Воронка → «Ваш Telegram id») и нажмите /start в боте.',
        not_a_tester: 'Сезон в тестовом режиме: сделайте себя тестировщиком в «Участниках».',
        wheel_hidden: 'Колесо выключено в настройках.',
      },
      fields: {
        name: 'Название',
        prizeName: 'Приз',
        prizeImage: 'Путь к фото приза',
        tz: 'Часовой пояс',
        startsAt: 'Начало',
        endsAt: 'Конец',
        drawAt: 'Финальный розыгрыш',
        startBonusVip: 'Стартовый бонус VIP',
        revealDays: 'Дней до полного раскрытия',
        sendTime: 'Время',
        dayOffset: 'День',
        condition: 'Условие',
        template: 'Текст сообщения',
        splitPct: 'Доля людей',
        label: 'Текст кнопки',
        action: 'Куда ведёт кнопка',
        buttons: 'Кнопки',
        quiet: 'Часы тишины',
        from: 'Тишина с',
        to: 'Тишина до',
        cap: 'Лимит сообщений в день',
        reward: 'Награда',
        url: 'Ссылка',
        title: 'Название',
        code: 'Код ссылки',
        source: 'Источник',
        codeWord: 'Кодовое слово',
        question: 'Вопрос',
        options: 'Варианты ответа',
        durationSec: 'Длительность',
        minWatchPct: 'Сколько досмотреть',
        maxReward: 'Максимальная награда',
        mainChannelId: 'Основной канал',
        vipChannelId: 'VIP-канал',
        discussionGroupId: 'Группа обсуждений',
        mainChannelLink: 'Ссылка на канал',
        supportUsername: 'Поддержка',
        welcomeVideo: 'Видео приветствия',
        ticketVideo: 'Видео билета',
        prize: 'Приз',
        scheduledAt: 'Время розыгрыша',
        text: 'Текст',
        at: 'Время отправки',
        email: 'Email',
        fileId: 'Файл',
        instructions: 'Что сделать',
      },
      step: {
        unknownFact: 'В условии неизвестное слово «{x}». Используйте данные из списка под полем.',
        unknownToken:
          'В тексте неизвестная подстановка «{x}». Используйте подстановки из списка под полем.',
        unknownFunction: 'В условии неизвестная функция {x}().',
        unexpected: 'В условии лишний или неверный символ «{x}».',
        expected: 'В условии не хватает «{x}».',
        unexpectedEnd: 'Условие обрывается — допишите его.',
        isList: '«{x}» — это список, его нельзя сравнивать напрямую.',
        emptyMessage: 'Текст сообщения пустой.',
      },
      seasonDates:
        'Проверьте даты: конец должен быть позже начала, а финальный розыгрыш — не раньше начала сезона.',
    },
  },
} as const;
